import { Button, Card, CardContent, Menu, TextField, Typography } from '@material-ui/core'
import { grey } from '@material-ui/core/colors'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import GetAppIcon from '@material-ui/icons/GetApp'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import PublishIcon from '@material-ui/icons/Publish'
import StopIcon from '@material-ui/icons/Stop'
import React, { useContext, useState } from 'react'
import MenuButton from '../../MenuButton'
import { getScaleChords } from '../../util/TonalUtils'
import { EditorActionType } from '../editorStore/backingTrackGeneratorEditorActions'
import BackingTrackEditorContext from '../editorStore/BackingTrackGeneratorEditorContext'
import EditorChordLength from './EditorChordLength'
import EditorSmallChordCard from './EditorSmallChordCard'

const demos: any[] = []

const MainControls = (props: {
	projectName: string,
	onProjectNameChange: (projectName: string) => void,
	onPlay: () => void,
	onPause: () => void,
	onStop: () => void,
	onLoadDemo: (demo: any) => void,
	isPlaying: boolean,
	onExportProject: () => void,
	onImportProject: () => void,
}) => {
	const {
		projectName,
		onProjectNameChange,
		onPlay,
		onPause,
		isPlaying,
		onStop,
		onLoadDemo,
		onExportProject,
		onImportProject,
	} = props

	const [editor, dispatchEditor] = useContext(BackingTrackEditorContext)

	const [loadDemoAnchorEl, setLoadDemoAnchorEl] = useState<null | HTMLElement>(null)

	const chords = getScaleChords(editor.config.scale)
	
	console.log({ chords })

	const handleChordCardClick = (chord: any) => {
		dispatchEditor({
			type: EditorActionType.ChordAdd,
			payload: {
				chord
			}
		})
	}

	return (
		<Card id="main-control" style={{ margin: '42px 24px', display: 'flex', alignItems: 'flex-end'  }}>
			<CardContent style={{
				flexGrow: 1,
				display: 'flex',
				// alignItems: 'flex-end',
				flexDirection: 'column'
			}}>
				<div style={{ flexGrow: 1, display: 'flex', alignItems: 'flex-end' }}>
				
					<TextField
						style={{ marginRight: 12 }}
						value={projectName}
						label='Project name'
						variant='filled'
						onChange={(e: any) => onProjectNameChange(e.target.value)}
					/>
					<Button
						// color='primary'
						startIcon={<PlayArrowIcon />}
						onClick={onPlay}
						disabled={isPlaying}
					>
						Play
					</Button>
					{/* <Button
						variant='contained'
						// color='primary'
						startIcon={<AddIcon />}
						onClick={onPause}
						disabled={!isPlaying}
					>
						Pause
					</Button> */}
					<Button
						// color='primary'
						startIcon={<StopIcon />}
						onClick={onStop}
						disabled={!isPlaying}
					>
						Stop
					</Button>
				
					<div style={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end' }}>
						<MenuButton
							buttonEl={
								<Button
									// color='primary'
									startIcon={<CloudDownloadIcon />}
								>
									Load demo
								</Button>
							}
							onItemClick={onLoadDemo}
							items={demos}
							getItemName={(demo: any) => demo.name}
						/>
						{/* <Button
							// color='primary'
							startIcon={<CloudDownloadIcon />}
							onClick={(e: any) => setLoadDemoAnchorEl(e.currentTarget)}
						>
							Load demo
						</Button>
						<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
							{({ TransitionProps, placement }) => (
								<Grow
									{...TransitionProps}
									style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
								>
									<Paper>
										<ClickAwayListener onClickAway={handleClose}>
											<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
													{demos.map((demo: any) => <MenuItem onClick={() => { setLoadDemoAnchorEl(null); onLoadDemo(demo) }}>{demo.name}</MenuItem>)}
											</MenuList>
										</ClickAwayListener>
									</Paper>
								</Grow>
							)}
						</Popper> */}
						<Menu
							anchorEl={loadDemoAnchorEl}
							keepMounted
							open={Boolean(loadDemoAnchorEl)}
							onClose={() => setLoadDemoAnchorEl(null)}
						>
						</Menu>
				
						<Button
							// color='primary'
							startIcon={<PublishIcon />}
							onClick={onExportProject}
						>
							Export
						</Button>
				
						<Button
							// color='primary'
							startIcon={<GetAppIcon />}
							onClick={onImportProject}
						>
							Import
						</Button>
				
					</div>
				
				</div>

				<div
					style={{
						borderTop: '1px solid ' + grey[700],
						marginTop: 24,
						display: 'flex',
						flexDirection: 'row',
						paddingTop: 16,
						paddingBottom: 8,
						height: 100,
					}}>

					<EditorChordLength />

					<div style={{ display: 'flex', flexDirection: 'column' }} id='main-control-chords'>
						<Typography variant='h6' style={{ marginBottom: 8 }}>Chords in {editor.config.scale}</Typography>
						
						<div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
							{chords.map((chord: any) => (
								<EditorSmallChordCard
									chord={chord}
									onClick={handleChordCardClick}
								/>
							))}
						</div>
					</div>

				</div>

			</CardContent>
		</Card>
	)
}

export default MainControls
